import React from 'react';
import { Mail, Phone, MapPin, Linkedin, Facebook, Twitter } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    company: [
      { name: 'About Us', href: '#about' },
      { name: 'Our Team', href: '#about' },
      { name: 'Careers', href: '#contact' },
      { name: 'News & Updates', href: '#contact' }
    ],
    services: [
      { name: 'Environmental Planning', href: '#services' },
      { name: 'Civil Engineering', href: '#services' },
      { name: 'Project Management', href: '#services' },
      { name: 'MEP Services', href: '#services' }
    ],
    resources: [
      { name: 'Case Studies', href: '#projects' },
      { name: 'Sustainability Report', href: '#contact' },
      { name: 'Industry Insights', href: '#contact' },
      { name: 'Contact Us', href: '#contact' }
    ]
  };

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-gray-300">
      {/* Main Footer Content */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-10 h-10 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-xl">E³</span>
              </div>
              <div className="flex flex-col">
                <span className="font-bold text-white text-lg leading-tight">
                  Eco Enviro Engineers
                </span>
                <span className="text-xs text-emerald-400">
                  Sustainable Solutions
                </span>
              </div>
            </div>
            <p className="text-sm text-gray-400 mb-6 leading-relaxed">
              Delivering innovative, sustainable, and efficient civil and environmental solutions through collaboration and technical excellence.
            </p>
            <div className="flex space-x-3">
              <a href="#" className="w-9 h-9 rounded-lg bg-gray-800 hover:bg-emerald-600 flex items-center justify-center transition-colors duration-200">
                <Linkedin size={18} />
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-gray-800 hover:bg-emerald-600 flex items-center justify-center transition-colors duration-200">
                <Facebook size={18} />
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-gray-800 hover:bg-emerald-600 flex items-center justify-center transition-colors duration-200">
                <Twitter size={18} />
              </a>
            </div>
          </div>

          {/* Company Links */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Company</h3>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    onClick={(e) => scrollToSection(e, link.href)}
                    className="text-sm text-gray-400 hover:text-emerald-400 transition-colors duration-200 inline-block"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services Links */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Services</h3>
            <ul className="space-y-3">
              {footerLinks.services.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    onClick={(e) => scrollToSection(e, link.href)}
                    className="text-sm text-gray-400 hover:text-emerald-400 transition-colors duration-200 inline-block"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <Mail size={18} className="text-emerald-400 mt-0.5 flex-shrink-0" />
                <a href="mailto:connect@ecoenviro.in" className="text-sm text-gray-400 hover:text-emerald-400 transition-colors duration-200">
                  connect@ecoenviro.in
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <Phone size={18} className="text-emerald-400 mt-0.5 flex-shrink-0" />
                <a href="tel:+918107010004" className="text-sm text-gray-400 hover:text-emerald-400 transition-colors duration-200">
                  +91 81070 10004
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin size={18} className="text-emerald-400 mt-0.5 flex-shrink-0" />
                <span className="text-sm text-gray-400">
                  2, Basant Vihar, Jagatpura<br />
                  Jaipur - 302031, India
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-sm text-gray-500">
            © {currentYear} Eco Enviro Engineers. All rights reserved.
          </p>
          <div className="flex space-x-6">
            <a href="#" className="text-sm text-gray-500 hover:text-emerald-400 transition-colors duration-200">
              Privacy Policy
            </a>
            <a href="#" className="text-sm text-gray-500 hover:text-emerald-400 transition-colors duration-200">
              Terms of Service
            </a>
            <a href="#" className="text-sm text-gray-500 hover:text-emerald-400 transition-colors duration-200">
              Cookie Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
